// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from '@rails/ujs'
import '@hotwired/turbo-rails'
import * as ActiveStorage from '@rails/activestorage'
import 'channels'
import 'controllers'
import '../stylesheets/tailwind.scss'
import Swal from 'sweetalert2'
import '../stylesheets/inquiry.css'

Rails.confirm = (message, element) => {
  const text = element.getAttribute('data-text')
  Swal.fire({
    title: message || '操作を実行してよろしいですか？',
    html: text || '',
    icon: element.getAttribute('data-icon'),
    confirmButtonText: 'はい',
    confirmButtonColor: '#40BF6C',
    cancelButtonText: 'キャンセル',
    showCancelButton: true,
    reverseButtons: true,
    focusCancel: true
  }).then(result => {
    if (result.isConfirmed) {
      const old = Rails.confirm
      Rails.confirm = () => true
      element.click()
      Rails.confirm = old
    }
  }).catch(error => {
    console.log(error)
  })

  return false
}

Rails.start()
ActiveStorage.start()
